import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IImage, IShowFullScreenPayload } from 'i2g-ng-ui';

@Component({
  selector: 'i2g-image-gallery',
  templateUrl: './image-gallery.component.html',
  styleUrls: ['./image-gallery.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageGalleryComponent implements OnInit {
  @HostBinding('class.hide-thumbnails')
  get profileComponentCSSClass(): boolean {
    return !this.showThumbnails;
  }

  @Input() showThumbnails = true;
  @Input() startIndex: number;
  @Input() images: IImage[];
  @Output()
  showFullScreen: EventEmitter<IShowFullScreenPayload> = new EventEmitter<IShowFullScreenPayload>();

  innerWidth: number;
  selectedIndex$ = new BehaviorSubject<number>(0);
  thumbnails: IImage[] = [];
  zoomEnlargeIcon = 'zoom-enlarge';
  arrowBackIcon = 'arrow-back';
  arrowForwardIcon = 'arrow-forward';

  ngOnInit() {
    this.thumbnails = this.showThumbnails ? this.images : null;
    this.selectedIndex$.next(this.startIndex || 0);
    this.innerWidth = window.innerWidth;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.innerWidth = window.innerWidth;
  }

  onSelectImage(index: number) {
    this.selectedIndex$.next(index);
    if (this.innerWidth < 768) {
      this.showFullScreen.emit({
        showFullScreen: true,
        index: index,
      });
    }
  }

  onPrevious() {
    const previousIndex = this.selectedIndex$.value - 1;
    this.selectedIndex$.next(previousIndex);
  }

  onNext() {
    const nextIndex = this.selectedIndex$.value + 1;
    this.selectedIndex$.next(nextIndex);
  }

  onFullScreen() {
    this.showFullScreen.emit({
      showFullScreen: true,
      index: this.selectedIndex$.value,
    });
  }
}
